import RecommenderBoxLabel from "./recommender-box-label";

export default { RecommenderBoxLabel };
